const TooltipIcon = () => {
  return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="18"
        viewBox="0 0 18 12"
        fill="none"
      >
        <path
          d="M8.52 11.36L16.32 0.96C16.6167 0.524512 16.3344 -4.76837e-07 15.84 -4.76837e-07H2.16C1.66563 -4.76837e-07 1.38334 0.524512 1.68 0.96L9.48 11.36C9.72 11.68 10.2 11.68 10.44 11.36Z"
          fill="#E9EEFE"
        />
      </svg>
  );
};
export default TooltipIcon;
